import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

export const useLogClickGoods = (logging: AnyObject) => {
  const screen = useAtomicScreen();

  return useCallback(
    (itemLogging: AnyObject) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...logging?.analytics,
          ...itemLogging?.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
      });
    },
    [logging, screen],
  );
};
